import styled from '@emotion/styled'

export const BillsPeriodSelector = styled.div`
  margin-left: auto;
`
